var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"menu"},[_c('Menu',{attrs:{"isCollapse":_vm.isCollapse}})],1),_c('div',{staticClass:"content",class:{small:_vm.isCollapse}},[_c('Content',{attrs:{"isCollapse":_vm.isCollapse},on:{"changeShow":_vm.changeShow}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }